import { connect } from 'react-redux';
import StartScreen from '../components/startPage/startScreen';
import PlayerState from '../PlayerState';
function getLocation(state) {
    const primaryActivity = Object.keys(state.scene.activities)[0];
    return primaryActivity ? state.scene.activities[primaryActivity].locationName : undefined;
}
const mapStateToProps = state => ({
    autoplay: state.scene.sceneSettings.autoplay,
    reverseHeaderLayout: state.scene.sceneSettings.reverseHeaderLayout,
    loadingPage: state.scene.loading,
    sceneTitle: state.scene.title,
    playerReady: state.loading.playerState > PlayerState.INITIALIZING,
    sceneReady: state.loading.scene.complete,
    playerStarted: state.loading.playerState >= PlayerState.LOADING,
    playerPlaying: state.loading.playerState >= PlayerState.PLAYING,
    loadingProgress: state.loading.progress,
    location: getLocation(state),
    isMobile: state.layout.isMobile,
});
const mapDispatchToProps = dispatch => ({
    onStartPlayer: () => {
        dispatch({ type: 'SET_USER_ENGAGED' });
        analytics.event({
            category: 'Player',
            action: 'start playing',
        });
    },
});
export default connect(mapStateToProps, mapDispatchToProps)(StartScreen);
